import {
    CssBaseline,
    StyledEngineProvider,
    ThemeProvider,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LicenseInfo } from "@mui/x-license";
import { Worker } from "@react-pdf-viewer/core";
import { QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { queryClient } from "@/api/queryClient";
import { Toaster } from "@/components/ui/sonner";
import { theme } from "./config/project.ts";

import { PostHogProvider } from "@posthog/react";

LicenseInfo.setLicenseKey(
    "627cafd2993e3327c90807ac3e7bc467Tz0xMjcwNTUsRT0xODA1MzI3OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI="
);

const posthogOptions = {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    defaults: "2026-01-30",
} as const;

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <PostHogProvider
            apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
            options={posthogOptions}
        >
            <QueryClientProvider client={queryClient}>
                <StyledEngineProvider enableCssLayer>
                    <ThemeProvider theme={theme}>
                        <CssBaseline enableColorScheme />
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                <App />
                            </Worker>
                        </LocalizationProvider>
                        <SnackbarProvider autoHideDuration={5000} />
                        <Toaster position="bottom-right" visibleToasts={3} />
                    </ThemeProvider>
                </StyledEngineProvider>
            </QueryClientProvider>
        </PostHogProvider>
    </React.StrictMode>
);
